<svg width="22" height="2" viewBox="0 0 22 2" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.175 -1.49012e-08C21.6219 -1.49012e-08 22 0.458333 22 1C22 1.54167 21.6219 2 21.175 2L0.825 2C0.378125 2 0 1.54167 0 1C0 0.458333 0.378125 -1.49012e-08 0.825 -1.49012e-08L21.175 -1.49012e-08Z" fill="currentColor"/>
</svg>
